/**
 * Creates an array of numbers progressing from start up to, but not including, end.
 * If only one argument is provided, it’s treated as the end and start = 0.
 *
 * Examples:
 * range(5)            -> [0,1,2,3,4]
 * range(1, 5)         -> [1,2,3,4]
 * range(0, 20, 5)     -> [0,5,10,15]
 * range(5, 0, -1)     -> [5,4,3,2,1]
 */
export function range(end: number): number[];
export function range(start: number, end: number, step?: number): number[];
export function range(startOrEnd: number, end?: number, step: number = 1): number[] {
    let start: number;
    let stop: number;

    if (end === undefined) {
        start = 0;
        stop = startOrEnd;
    } else {
        start = startOrEnd;
        stop = end;
    }

    if (step === 0) {
        throw new Error('range() step cannot be 0');
    }

    const result: number[] = [];

    // Auto-correct step direction if omitted
    if (start < stop && step < 0) step = Math.abs(step);
    if (start > stop && step > 0) step = -step;

    if (step > 0) {
        for (let i = start; i < stop; i += step) {
            result.push(i);
        }
    } else {
        for (let i = start; i > stop; i += step) {
            result.push(i);
        }
    }

    return result;
}
